import { FC, useCallback } from "react";
import { Box, Drawer } from "@mui/material";
import { ReservedInstanceDrawerContent } from "./reserved-instance-drawer/ReservedInstanceDrawerContent";
import { ReservationCoverageDrawerContent } from "./coverage-drawer/ReservationCoverageDrawerContent";
import { commitmentsDrawerResizingDefaultParams } from "../../../common/utils/constants/drawerResizingDefaultParams";
import { ResourceDetailsDragHandler } from "../../../../common/resource-details/components/ResourceDetailsDragHandler";
import { useAppDispatch, useAppSelector } from "@/store/hooks";
import { setCommitmentsDetailsRequestData } from "@/store/commitments/commitmentsSlice";
import { commitmentsDetailsDrawerTargetTypeSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerTargetTypeSelector";
import { commitmentsDetailsDrawerOpenSelector } from "@/store/commitments/selectors/common/details-drawer/commitmentsDetailsDrawerOpenSelector";
import { usePanelHorizontalResize } from "@/components/utils/hooks/usePanelHorizontalResize";

export const ReservationsDrawers: FC = () => {
  const dispatch = useAppDispatch();
  const targetType = useAppSelector(commitmentsDetailsDrawerTargetTypeSelector);
  const open = useAppSelector(commitmentsDetailsDrawerOpenSelector);

  const { width, handleMouseDown } = usePanelHorizontalResize(
    commitmentsDrawerResizingDefaultParams,
  );

  const closeHandler = useCallback(() => {
    dispatch(setCommitmentsDetailsRequestData(undefined));
  }, [dispatch]);

  return (
    <Drawer
      open={open}
      anchor="right"
      onClose={closeHandler}
      PaperProps={{ sx: { width, overflow: "hidden" } }}
    >
      <ResourceDetailsDragHandler onMouseDown={handleMouseDown} />

      <Box overflow="auto" height="100%">
        {targetType === "commitment" && (
          <ReservedInstanceDrawerContent onClose={closeHandler} />
        )}

        {targetType === "account" && (
          <ReservationCoverageDrawerContent onClose={closeHandler} />
        )}

        {targetType === "resource_type" && (
          <ReservationCoverageDrawerContent onClose={closeHandler} />
        )}
      </Box>
    </Drawer>
  );
};
